/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Delete_Terms_TitleInputs */



/**
* | output |
* | --- |
* | "Delete Terms?" |
*
* @param {Knp_Terms_Delete_Terms_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_delete_terms_title = /** @type {((inputs?: Knp_Terms_Delete_Terms_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Delete_Terms_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer les termes ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungsbedingungen löschen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminare i termini?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить условия?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Eliminar términos?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除条款？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("利用規約を削除しますか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शर्तें हटाएं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir termos?")
	return /** @type {LocalizedString} */ ("Delete Terms?")
});